/**
 * Auth DTOs (98 Round 7 S-auth: email + password, no OTP).
 *
 * - `POST /v1/auth/register` {email, password, dob}: the DOB is checked **before any write**;
 *   under 18 → `under_age` and nothing is stored (Q-23). The email must be on the tester
 *   allowlist (`not_invited`). Success sets the session cookie (92 A2) and returns `AuthResponse`.
 * - `POST /v1/auth/login` {email, password}: wrong email or password → `invalid_credentials`
 *   (one generic error). Rate-limited per IP and per email. Success sets the cookie.
 * - `POST /v1/auth/logout`: no body; revokes the session and clears the cookie → 204.
 */
import { z } from 'zod';
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;
export const MIN_AGE_YEARS = 18;
/** httpOnly, SameSite=Lax, 30 days (92 A2). */
export const SESSION_COOKIE = 'enugu_session';
const Email = z.string().trim().toLowerCase().pipe(z.email().max(254));
const Password = z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH);
export const RegisterRequestSchema = z.object({
    email: Email,
    password: Password,
    /** `YYYY-MM-DD`. */
    dob: z.iso.date(),
});
export const LoginRequestSchema = z.object({
    email: Email,
    // Any non-empty string: length rules apply at registration only.
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
/**
 * 2xx body of `GET /v1/me`, `register` and `login`: the account and its character
 * (null until `POST /v1/characters`).
 */
export const MeResponseSchema = z.object({
    account: z.object({ id: z.uuid(), email: z.string() }),
    character: z
        .object({
        id: z.uuid(),
        name: z.string(),
        body: z.union([z.literal(0), z.literal(1)]),
        look: z.record(z.string(), z.number()),
        phoneNumber: z.string(),
        areaId: z.string(),
    })
        .nullable(),
});
